export { default } from "./loadPanel";
